export const Config = {
  // API_HOST_URL_live: "http://localhost:3030",
   API_HOST_URL_live: "https://api.figk12pos.com",
   HOST_URL_live: "https://figk12pos.com",
  //API_HOST_URL_live: "http://posapi.vidhaninfotech.com",
  //API_HOST_URL_live: "https://localhost:7185",
  //HOST_URL_live: "http://reactpos.vidhaninfotech.com",
};
